

















































































































import { computed, defineComponent, onMounted, PropType } from '@nuxtjs/composition-api';
import useResponsive from '@shared/composables/useResponsive';
import useShopifyCategories from '@shared/composables/useShopifyCategories';
import getSearchQueryLink from '@shared/composables/useUiHelpers/getSearchQueryLink';
import { getSearchCategoryFilters } from '@shared/helpers/search/getSearchCategoryFilters';
import { CSSClass } from '@shared/types/vue';
import { BaseButton, BaseHeading, BaseList, BaseListItem, BaseLoader } from '@shared/ui';
import {
  ISearchProductsResponse,
  productResultGetters,
  searchGetters,
} from '@unified-commerce/gpc-vue-storefront-search';

import MiniProductCard from '~/components/ProductCard/MiniProductCard.vue';
import SearchBarPopularSearches from '~/components/SearchBarResults/SearchBarPopularSearches.vue';
import SearchResultsBrands from '~/components/SearchResultsBrands/SearchResultsBrands.vue';
import { BASE_SEARCH_PATH } from '~/constants';
import ArrowRight from '~/static/icons/arrow-right.svg?inline';

import SearchResultsCategories from '../SearchResultsCategories/SearchResultsCategories.vue';
export default defineComponent({
  name: 'SearchBarResults',
  components: {
    SearchBarPopularSearches,
    MiniProductCard,
    BaseList,
    BaseListItem,
    BaseLoader,
    BaseButton,
    SearchResultsCategories,
    SearchResultsBrands,
    BaseHeading,
    ArrowRight,
  },
  inject: {
    brands: {
      from: 'brands',
    },
  },
  props: {
    searchResult: {
      type: [Object, Array] as PropType<ISearchProductsResponse>,
      default: null,
    },
    searchResultLoading: {
      type: Boolean,
      required: true,
    },
    searchValue: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { shopifyCategories } = useShopifyCategories();
    const { isMobile } = useResponsive();

    const sortedSearchResultCategories = computed(() => {
      if (!props.searchResultLoading && !!props.searchResult?.results) {
        return getSearchCategoryFilters(props.searchResult, shopifyCategories.value, true);
      }
      return [];
    });

    const popularSearches = computed(() =>
      props.searchResult ? searchGetters.getPopularSearches(props.searchResult) : [],
    );

    const hasPopularSearches = computed(() => !!popularSearches.value?.length);

    return {
      sortedSearchResultCategories,
      productResultGetters,
      searchGetters,
      popularSearches,
      hasPopularSearches,
      isMobile,
    };
  },
  data() {
    const tabOpen = 'products';
    const tabs = ['products', 'brands', 'categories'];

    return {
      tabOpen,
      tabs,
    };
  },
  computed: {
    hasResults(): boolean {
      return !!this.searchResult?.results?.length;
    },
    noResultsMessage(): string {
      return `Sorry, we couldn't find any ${this.tabOpen} for "${this.searchValue}"`;
    },
    noResultsTitle(): string {
      return `No ${this.tabOpen} found`;
    },
    noBrandsMessage(): string {
      return `Sorry, we couldn't find any brands for "${this.searchValue}"`;
    },
    viewButtonLink(): string {
      if (this.hasResults) {
        return getSearchQueryLink(this.searchValue);
      }

      return BASE_SEARCH_PATH;
    },
    searchBarResultsBrands(): CSSClass[] {
      const baseClass = 'search-bar-results__brands';
      const activeClass = `${baseClass}--active`;

      return [
        baseClass,
        {
          [activeClass]: this.tabOpen === 'brands',
        },
      ];
    },
    searchBarResultsProducts(): CSSClass[] {
      const baseClass = 'search-bar-results__products';
      const activeClass = `${baseClass}--active`;

      return [
        baseClass,
        {
          [activeClass]: this.tabOpen === 'products',
        },
      ];
    },
    searchBarResultsCategories(): CSSClass[] {
      const baseClass = 'search-bar-results__categories';
      const activeClass = `${baseClass}--active`;

      return [
        baseClass,
        {
          [activeClass]: this.tabOpen === 'categories',
        },
      ];
    },
  },
  methods: {
    onTabClick(tab: string) {
      this.tabOpen = tab;
    },
    searchBarResultsTabClasses(tab: string): CSSClass[] {
      const baseClass = 'search-bar-results__tab';
      const activeClass = `${baseClass}--active`;

      return [
        baseClass,
        {
          [activeClass]: tab === this.tabOpen,
        },
      ];
    },
  },
});
